import React from "react";
import { useQuery } from "react-apollo";
import { oc } from "ts-optchain";
import { FavoriteBrands, FAVORITE_BRANDS_QUERY } from "@queries";
import { Text } from "@atoms";
import BrandFavoritesDialer from "./BrandFavoritesDialer";
// import styled from "@emotion/styled";

// == Types ================================================================

// == Constants ============================================================

// == Component ============================================================

export const BrandFavoritesDialerQuery = () => {
  const { data, error } = useQuery<FavoriteBrands>(FAVORITE_BRANDS_QUERY);
  if (error) {
    return <Text>{error.message}</Text>;
  }
  const brands = oc(data).Viewer.favoriteBrands();
  if (!brands) return null; // return error
  return <BrandFavoritesDialer brands={brands} />;
};

// == Styles ===============================================================
